// import {
//   createSlice,
//   createAsyncThunk,
// } from "@reduxjs/toolkit";

// import {
//   adminContactApi,
//   getContactApi
// } from "../../api/adminContactApi";

// export const createContact = createAsyncThunk(
//   "adminContact/createContact",
//   async (contactData, thunkAPI) => {
//     try {
//       const response = await adminContactApi(contactData);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

// export const getContacts = createAsyncThunk(
//   "adminContact/getContacts",
//   async (_, thunkAPI) => {
//     try {
//       const response = await getContactApi();
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response.data);
//     }
//   }
// );

// const initialState = {
//   contacts: [],
//   loading: false,
//   error: null,
// };

// const adminContactSlice = createSlice({
//   name: "adminContact",
//   initialState,
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(createContact.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(createContact.fulfilled, (state, action) => {
//         state.loading = false;
//         state.contacts.push(action.payload);
//       })
//       .addCase(createContact.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload.message;
//       })
//       .addCase(getContacts.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(getContacts.fulfilled, (state, action) => {
//         state.loading = false;
//         state.contacts = action.payload;
//       })
//       .addCase(getContacts.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload.message;
//       });
//   },
// });

// export const { clearError } = adminContactSlice.actions;

// export default adminContactSlice.reducer;

import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  adminContactApi,
  getContactApi
} from "../../api/adminContactApi";

export const createContact = createAsyncThunk(
  "adminContact/createContact",
  async (contactData, thunkAPI) => {
    try {
      const response = await adminContactApi(contactData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: "Failed to send message" });
    }
  }
);

export const getContacts = createAsyncThunk(
  "adminContact/getContacts",
  async (_, thunkAPI) => {
    try {
      const response = await getContactApi();
      // response structure: { success: true, data: [...] }
      return response.data; // This returns { success: true, data: [...] }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: "Failed to fetch contacts" });
    }
  }
);

const initialState = {
  contacts: [], // This will store the data array
  loading: false,
  error: null,
};

const adminContactSlice = createSlice({
  name: "adminContact",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createContact.fulfilled, (state, action) => {
        state.loading = false;
        // Assuming API returns the created contact data
        state.contacts = [...state.contacts, action.payload];
      })
      .addCase(createContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to send message";
      })
      .addCase(getContacts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContacts.fulfilled, (state, action) => {
        state.loading = false;
        // The API returns { success: true, data: [...] }
        // We need to extract the data array
        if (action.payload && action.payload.data) {
          state.contacts = action.payload.data;
        } else if (Array.isArray(action.payload)) {
          state.contacts = action.payload;
        } else {
          state.contacts = [];
        }
      })
      .addCase(getContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch contacts";
      });
  },
});

export const { clearError } = adminContactSlice.actions;

export default adminContactSlice.reducer;